<template>
  <div class="flex h-full w-full">
    <router-view />
  </div>
</template>
